import { useQuery } from '@tanstack/react-query';
import { printApi } from '../api/print.api';

export const usePrinters = () => {
  return useQuery({
    queryKey: ['printers'],
    queryFn: () => printApi.getAvailablePrinters(),
    staleTime: 30000, // Cache for 30 seconds
  });
};

